import navToggle from "../actions/navToggle";
import peakABooHeader from "../actions/peakABooHeader";
import subMenuToggle from "../actions/subMenuToggle";
import renderSiteSearch from "../actions/renderSiteSearch";

/**
 * header.js
 *
 * Functionality related to the site header
 *
 *
 * @param $ jQuery
 */
const Header = ($) => {
	navToggle($);
	subMenuToggle($);
	peakABooHeader($)
	renderSiteSearch($); //  keeping for when we add site search 

};

export default Header;
